import { isPlatformServer } from '@angular/common';
import { DestroyRef, inject, Injectable, makeStateKey, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TransferState } from '@angular/platform-browser';
import { InternationalHotelsRepository } from '@core/services/repositories/international-hotels.repository';
import { Observable, tap } from 'rxjs';


const HOTELS_KEY = makeStateKey<any[]>('intl-hotels');

@Injectable({
  providedIn: 'root'
})
export class InternationalHotelsService {
  hotels: WritableSignal<any | null> = signal(null);
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  private destroyRef = inject(DestroyRef);
  private repo = inject(InternationalHotelsRepository)

  constructor() { }

  getHotels(): Observable<any> | void {
    const cached = this.transferState.get(HOTELS_KEY, null);
    const hotels$ = this.repo.getInternationalHotels().pipe(
      tap((res) => {
        this.hotels.set(res);
        this.transferState.set(HOTELS_KEY, res);
      })
    );

    if (isPlatformServer(this.platformId)) {
      return hotels$; 
    } else {
      if (cached) {
        this.hotels.set(cached);
        this.transferState.remove(HOTELS_KEY); 
      } else {
        hotels$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
      }
    }
  }
}
